import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Stack, Divider } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import validationSchema from "./schema";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import StyledButton from "../../../../Reuse/UI/StyledButton";
import RangeInput from "./RangeInput";
import { droneStatus, droneTypes, sortOption } from "../Context";
import { StyledSelectInput } from "../../../../Reuse/FormInput";
import {
  encodeParamsFromValues,
  decodeParamsToValues,
} from "../../../../utils/queryParams";

const FilterForm = ({ defaultFilter, handleClose }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialParams = {};
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: initialParams,
    resolver: yupResolver(validationSchema),
  });

  /**
   * Submits filter form: updates query params and closes the modal
   */
  const onSubmit = async (values) => {
    const newParams = encodeParamsFromValues(values, searchParams);
    setSearchParams(newParams);
    handleClose();
  };

  /**
   * Clears all filters by removing their keys from the URL and resetting the form
   */
  const onClear = () => {
    const clearedParams = new URLSearchParams(searchParams.toString());
    defaultFilter.forEach((el) => clearedParams.delete(el.keyName));
    setSearchParams(clearedParams);
    const paramData = decodeParamsToValues(clearedParams, defaultFilter);
    reset({ ...paramData });
    handleClose();
  };

  /**
   * On mount or param change, populate form with query values
   */
  useEffect(() => {
    reset(decodeParamsToValues(searchParams, defaultFilter));
  }, [searchParams, defaultFilter, reset]);

  const ActiveDrones = useMemo(() => <RangeInput
    label="Filter by number of Available Drones"
    parentId="active_drones"
    control={control}
    errors={errors}
    setValue={setValue}
  />, [control, errors, setValue]);

  const FloorNumber = useMemo(() => <RangeInput
    label="Filter by Floor Number"
    parentId="floor_number"
    control={control}
    errors={errors}
    setValue={setValue}
  />, [control, errors, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="column" gap={2}>
        <StyledSelectInput
          name="sort_by"
          control={control}
          label="Sort by"
          placeholder="Sort By"
          optionList={sortOption}
        />

        <Divider flexItem />

        {ActiveDrones}

        <StyledSelectInput
          name="drone_types"
          control={control}
          label="Filter by Drone Types"
          placeholder="Filter by Drone Types"
          optionList={droneTypes}
          multiple
        />

        {FloorNumber}

        {/* <RangeInput
          label="Filter by Drone Box Capacity"
          parentId="drone_box_capacity"
          control={control}
          errors={errors}
          setValue={setValue}
        /> */}

        <StyledSelectInput
          name="operational_statuses"
          control={control}
          label="Filter by Operational Statuses"
          placeholder="Filter by Operational Statuses"
          optionList={droneStatus}
        />

        <Stack direction="row" justifyContent="space-between">
          <StyledButton
            variant="outlined"
            startIcon={<ClearRoundedIcon />}
            onClick={onClear}
          >
            Clear
          </StyledButton>
          <StyledButton variant="contained" type="submit">
            Apply
          </StyledButton>
        </Stack>
      </Stack>
    </form>
  );
};

export default FilterForm;
